import styled from "styled-components";

export const MainDiv = styled.div`
  margin: auto;
  padding: 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  gap: 16px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const Title = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const GrayText = styled.p`
  color: #808080;
  font-size: 14px;
  font-weight: 400;
`;
export const EmotionalAlignerDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;
export const EmotionalAnswerDiv = styled.div`
  padding: 8px 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  border: ${({ border }) => border && border};
  background-color: ${({ background }) => background && background};
  gap: 4px;
`;
export const EmotionalValue = styled.p`
  color: ${({ color }) => color && color};
  font-size: 24px;
  font-weight: 600;
`;
export const Span = styled.span`
  opacity: 0.5;
`;
export const EmotionalText = styled.p`
  color: ${({ color }) => color && color};
  font-size: 14px;
  font-weight: 400;
`;
